import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card/hover-card";
import { BreakList } from "@/components/break/break-list";
import { formatDuration } from "@/components/break/format";
import type { BreakView } from "@/components/break/types";

export const BreaksCell = ({ breaks }: { breaks: BreakView[] }) => {
  if (breaks.length === 0) {
    return (
      <span className="text-muted-foreground" data-testid="breaks-cell-empty">
        —
      </span>
    );
  }

  const total = breaks.reduce((sum, b) => sum + b.durationSeconds, 0);

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <button
          type="button"
          className="underline decoration-dotted underline-offset-4"
          data-testid="breaks-cell"
        >
          {breaks.length} {breaks.length === 1 ? "break" : "breaks"} · {formatDuration(total)}
        </button>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <BreakList breaks={breaks} />
      </HoverCardContent>
    </HoverCard>
  );
};
